import { SuspenseErrorBoundary } from '@/components/SuspenseErrorBoundary';
import { GetInvoiceReportSummaryResponse } from 'ap-openapi';
import classnames from 'classnames/bind';
import { FC, memo } from 'react';
import { LeftContent } from './LeftContent';
import { RightContent } from './RightContent';
import styles from './styles.module.scss';

const cx = classnames.bind(styles);

type InvoiceReportDetailProps = {
  summaryData?: GetInvoiceReportSummaryResponse;
  isLoading: boolean;
  reportId: string;
};

const InnerDetail: FC<InvoiceReportDetailProps> = ({
  summaryData,
  isLoading,
  reportId,
}) => {
  return (
    <div className={cx('detail')}>
      <LeftContent
        data={summaryData}
        isLoading={isLoading}
        reportId={reportId}
      />
      <RightContent reportId={reportId} />
    </div>
  );
};

export const InvoiceReportDetail: FC<InvoiceReportDetailProps> = memo(
  (props) => {
    return (
      <SuspenseErrorBoundary>
        <InnerDetail {...props} />
      </SuspenseErrorBoundary>
    );
  }
);

InvoiceReportDetail.displayName = 'InvoiceReportDetail';
